import React, { useEffect, useState } from 'react';
import api from '../services/api';
import './AdminUserDetail.css';

function formatDate(ts) {
  if (!ts) return 'Never';
  return new Date(ts).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
}

function AdminUserDetail({ userId, onClose }) {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!userId) return;
    setIsLoading(true);
    setError(null);
    api.get(`/admin/users/${userId}`)
      .then(res => setData(res.data))
      .catch(err => setError(err.response?.status === 403 ? 'Access denied' : 'Failed to load user'))
      .finally(() => setIsLoading(false));
  }, [userId]);

  if (!userId) return null;

  const user = data?.user;
  const properties = data?.properties || [];
  const tier = (user?.subscription_tier || 'free').toLowerCase();

  return (
    <div className="aud-overlay" onClick={onClose}>
      <div className="aud-dialog" onClick={e => e.stopPropagation()}>

        <div className="aud-header">
          <div className="aud-header-left">
            <div className="aud-title">User Profile</div>
            {user && <div className="aud-subtitle">{user.email}</div>}
          </div>
          <button className="aud-close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="aud-body">
          {isLoading && <div className="aud-loading">Loading...</div>}
          {error && <div className="aud-error">{error}</div>}

          {user && (
            <>
              <div className="aud-section">
                <div className="aud-section-title">Account Info</div>
                <div className="aud-info-grid">
                  <span className="aud-info-label">Email</span>
                  <span className="aud-info-value">{user.email}</span>

                  <span className="aud-info-label">Joined</span>
                  <span className="aud-info-value">{formatDate(user.created_at)}</span>

                  <span className="aud-info-label">Account age</span>
                  <span className="aud-info-value">{user.account_age_days} days</span>

                  <span className="aud-info-label">Last login</span>
                  <span className="aud-info-value">{formatDate(user.last_login_at)}</span>

                  <span className="aud-info-label">Email verified</span>
                  <span className="aud-info-value">{user.email_verified ? 'Yes' : 'No'}</span>

                  <span className="aud-info-label">Auth type</span>
                  <span className="aud-info-value">{user.auth_type || '—'}</span>

                  <span className="aud-info-label">Subscription</span>
                  <span className="aud-info-value">
                    <span className={`aud-tier-badge aud-tier-badge--${tier}`}>{tier}</span>
                  </span>

                  <span className="aud-info-label">Admin</span>
                  <span className="aud-info-value">{user.is_admin ? 'Yes' : 'No'}</span>
                </div>
              </div>

              <div className="aud-section">
                <div className="aud-section-title">Activity Summary</div>
                <div className="aud-stat-grid">
                  {[
                    { label: 'Properties', value: user.property_count },
                    { label: 'Plants',     value: user.plant_count },
                    { label: 'Photos',     value: user.photo_count },
                    { label: 'Tasks',      value: user.task_count },
                  ].map(({ label, value }) => (
                    <div key={label} className="aud-stat-cell">
                      <div className="aud-stat-value">{value}</div>
                      <div className="aud-stat-label">{label}</div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="aud-section">
                <div className="aud-section-title">Properties</div>
                {properties.length === 0 ? (
                  <div className="aud-empty">No properties yet</div>
                ) : (
                  <div className="aud-properties-list">
                    {properties.map(p => (
                      <div key={p.id} className="aud-property-card">
                        <div className="aud-property-name">{p.name}</div>
                        <div className="aud-property-grid">
                          <span className="aud-info-label">Address</span>
                          <span className="aud-info-value">{p.address || '—'}</span>

                          <span className="aud-info-label">USDA zone</span>
                          <span className="aud-info-value">{p.usda_zone || '—'}</span>

                          <span className="aud-info-label">Last frost</span>
                          <span className="aud-info-value">{formatDate(p.last_frost_date)}</span>

                          <span className="aud-info-label">First frost</span>
                          <span className="aud-info-value">{formatDate(p.first_frost_date)}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </>
          )}
        </div>

        <div className="aud-footer">
          <button className="aud-footer-close-btn" onClick={onClose}>Close</button>
        </div>

      </div>
    </div>
  );
}

export default AdminUserDetail;
